// Shared helpers for priority sync routing (web + native).
export const LIVE_MODULE_COLLECTION_MAP = Object.freeze({
  purchases:          "orders",
  orders:             "orders",
  suppliers:          "orders",        // v3.7.00: aba de fornecedores está dentro do hub de Compras
  services:           "services",
  service:            "services",
  services_external:  "services",      // v3.7.00: Serviços Terceirizados → collection services
  occurrences:        "occurrences",
  occurrence:         "occurrences",
  // Mapeados mas ainda não confirmados na lane técnica (push_ops/pull_delta/ACK):
  vet:                "vet",
  veterinary:         "vet",
  inspections:        "inspections",
  inspection:         "inspections",
  // NÃO adicionar: animals, machinery, haras, aviculture — aguardam auditoria técnica
});

export function normalizePriorityModuleId(moduleId) {
  return String(moduleId || "").trim().toLowerCase();
}

export function collectionForPriorityModule(moduleId) {
  const key = normalizePriorityModuleId(moduleId);
  return LIVE_MODULE_COLLECTION_MAP[key] || "";
}

// v3.7.00: collections atualmente na lane operacional técnica (push_ops/pull_delta/ACK).
// Atualizar aqui quando novos módulos forem auditados e confirmados na lane.
export const OPERATIONAL_LANE_COLLECTIONS = new Set([
  "orders",
  "services",
  "occurrences",
]);
